import React, { useState, useEffect } from 'react';
import { getFavouritePlaylist } from 'services/post';
import { notifyError } from '../notifications';

export const FavouritesContext = React.createContext({});
FavouritesContext.displayName = 'Favourites';

const initState = {
  PlaylistItemMap: {},
  title: '',
  kudos: 0,
  description: '',
  follows: 0,
  uploader: 0,
  private: undefined,
  created_at: '',
};

export const FavouritesContextProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [playListData, setPlayListData] = useState(initState);
  const [isPrivateList, setIsPrivateList] = useState(false);

  const getCurrentFavouritePlayList = async () =>
    getFavouritePlaylist()
      .then((favourite) => {
        setPlayListData(favourite.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        error.response && error.response.status === 401
          ? setIsPrivateList(true)
          : notifyError(error);
      });

  useEffect(() => {
    getCurrentFavouritePlayList();
  }, []);

  return (
    <FavouritesContext.Provider
      value={{
        loading,
        isPrivateList,
        playListData,

        // playlistItems,
        // totalPlaylistDuration,
        // deleteItemFromPlaylist,
      }}
    >
      {children}
    </FavouritesContext.Provider>
  );
};
